<template lang="html">
  <div class="">
    <h1  style="margin-left: 140px">
      Modulo
      <span v-if="is_inv">Fattura</span>
      <span v-if="is_nacc">Nota di credito</span>
      <span v-if="is_ric">Ricevuta</span>
    </h1>
    <br>
    <!-- {{$store.company.cc}} -->
    <Form ref="form" :model="form">
      <FormItem v-if="!form.is_a" :label-width="140" label="Tipologia" prop="type" :rules="req">
        <Select v-model="form.is_a" style="max-width:200px!important">
          <Option value="inv">
            Fattura
          </Option>
          <Option value="nacc">
            Nota d'Accredito
          </Option>
          <Option value="ric">
            Ricevuta
          </Option>
        </Select>
      </FormItem>

      <FormItem v-if="is_inv" :label-width="140" label="Tipo" prop="type" :rules="req">
        <RadioGroup v-model="form.type">
          <Radio label="sent">
            Fattura Emessa
          </Radio>
          <Radio label="rec">
            Fattura Ricevuta
          </Radio>
        </RadioGroup>
      </FormItem>

      <FormItem v-if="is_nacc" :label-width="140" label="Tipo" prop="type" :rules="req">
        <RadioGroup v-model="form.type">
          <Radio label="sent">
            Nota di Credito Emessa
          </Radio>
          <Radio label="rec">
            Nota di Credito Ricevuta
          </Radio>
        </RadioGroup>
      </FormItem>

      <FormItem v-if="is_inv_or_nacc" :label-width="140" :label="(form.type=='sent'?'Cliente':'Fornitore')" prop="contact_id" :rules="req">
        <div class="">
          <Select v-model="form.contact_id" :disabled="!contacts" filterable>
            <Option v-if="contacts" v-for="c in contacts" :key="c.id" :value="c.id">{{ c.name }}</Option>
          </Select>
          &nbsp;
          <Button @click="$root.$emit('contact.show')">
            Nuovo contatto
          </Button>
        </div>
      </FormItem>
      <FormItem v-else-if="is_ric" :label-width="140" label="Denominazione" prop="contact_str" :rules="req">
        <div class="">
          <Input type="text" v-model="form.contact_str"/>
        </div>
      </FormItem>

      <FormItem :label-width="140" label="Data" prop="date" :rules="req">
        <LocalDate v-model="form.date"/>
      </FormItem>

      <FormItem :label-width="140" label="Numero" prop="number" :rules="req" v-if="is_inv_or_nacc">
        <div class="">
          <Input number v-model="form.number"/>
        </div>
      </FormItem>

      <FormItem v-if="is_inv" :label-width="140" label="Ritenuta d'acconto" prop="ritenuta">
        <div class="">
          <NumInput v-model="form.ritenuta"/>
        </div>
      </FormItem>

      <FormItem v-if="form.id" :label-width="140" label="Protocollo" prop="protocol" :rules="req">
        <div class="">
          <Input number v-model="form.protocol"/>
        </div>
      </FormItem>

      <FormItem :label-width="140" label="Totale">
        {{ $n(sum, 'currency') }}
      </FormItem>

      <FormItem :label-width="140" label="Note" prop="notes">
        <div class="">
          <Input v-model="form.notes"/>
        </div>
      </FormItem>

      <!-- <Tabs type="card"> -->
        <!-- <TabPane :label="'Servizi ' + (form.type == 'rec' ? 'ricevuti' : 'offerti')"> -->
        <hr>
        <div style="">
          <div style="min-width: 700px">
            <Row :gutter="16">
              <Col span="4">
                Descrizione
              </Col>
              <Col span="6">
                Conto
              </Col>
              <Col span="3">
                {{ has_iva_controls ? 'Imponibile' : 'Ammontare' }} €
              </Col>
              <Col span="2" v-if="has_iva_controls">
                + IVA %
              </Col>
              <Col span="3" v-if="has_iva_controls">
                Totale €
              </Col>
              <Col span="4" v-if="has_iva_controls">
                &nbsp;
                IVA scaricabile (0-100%)
              </Col>
            </Row>
            <Row :gutter="16" v-for="(line, i) in form.items" :key="line.id">
              <Col span="4">
                <FormItem :prop="`items.${i}.description`" :rules="req">
                  <AutoComplete
                  v-model="line.description"
                  :data="[]"
                  :filter-method="autofilter"
                  placeholder="Descrizione"
                  icon="ios-pricetags">
                </AutoComplete>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem :prop="`items.${i}.ledger_id`" :rules="req">
                <LedgerSelect v-model="line.ledger_id" :ledgers="ledgers" @input="autoSetIva(line)"/>
              </FormItem>
            </Col>
            <Col span="3">
              <FormItem :prop="`items.${i}.amount`" :rules="req">
                <NumInput right :step="1" v-model="line.amount" @keyup.native="$set(line, 'total', (line.amount / 100 * ( 100 + 1*line.iva_percent )).toFixed(2))"/>
              </FormItem>
            </Col>
            <Col span="2" v-if="has_iva_controls">
              <FormItem :prop="`items.${i}.iva_percent`" :rules="req">
                <Select v-model="line.iva_percent" transfer @input="updateAmountOfLine(line)" :disabled="true">
                  <Option v-for="i in [0, 4, 5, 10, 22]" :key="i" :value="i">{{ i }}%</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="3">
              <FormItem :prop="`items.${i}.total`" :rules="req">
                <NumInput right :step="1" v-model="line.total"  @keyup.native="updateAmountOfLine(line)"/>
              </FormItem>
            </Col>
            <Col span="3" v-if="has_iva_controls">
              <FormItem :prop="`items.${i}.scaricabile`" :rules="req">
                <NumInput right :min="0" :max="100" :step="1" v-model="line.scaricabile" :disabled="true"/>
              </FormItem>
            </Col>
            <Col span="1">
              <Button type="error" @click="form.items.splice(i, 1)">
                <Icon type="ios-trash" size="small"/>
              </Button>
            </Col>
          </Row>
          <div style="text-align: left">
            <Button @click="addLine()">Aggiungi linea</Button>
          </div>

          </div>
        </div>

        <!-- </TabPane> -->
        <!-- <TabPane label="Pagamenti e scadenze"> -->
        <div style="overflow-x: auto">
          <div style="min-width: 700px">
            <div class="">
              <br>
              <hr>
              <br>
              <h2>{{ generates_credit ? 'Pagamenti da incassare' : 'Rateizza pagamento' }}</h2>
              <i>In caso di mancata compilazione, verrà creata una scadenza in 30 giorni che potrà essere modificata in seguito</i>

              <div v-if="!form.payments.length">
              </div>
              <div v-else class="ivu-table spaced">
                <table>
                  <thead>
                    <tr>
                      <th style="width: 150px">Data</th>
                      <th>Metodo</th>
                      <th style="width: 100px">Ammontare</th>
                      <th style="width: 100px">Pagato</th>
                      <th style="width: 50px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, i) in form.payments" style="margin-top: 10px">
                      <td>
                        <FormItem :prop="`payments.${i}.date`" :rules="req">
                          <LocalDate placement="top" v-model="p.date"/>
                        </FormItem>
                      </td>
                      <td>
                        <div v-if="p.date > (new Date).serializeLocal()">
                          Da impostare al momento del pagamento
                        </div>
                        <FormItem v-else :prop="`payments.${i}.ledger_id`" :rules="p.is_paid ? req : {}">
                          <Select transfer v-model="p.ledger_id" filterable :loading="!ledgers" style="max-width: 200px">
                            <Option v-for="l in cassa_e_banca" :value="l.id" :key="l.id">[{{ l.code }}] {{ l.name }}</Option>
                          </Select>
                        </FormItem>
                      </td>
                      <td>
                        <FormItem :prop="`payments.${i}.amount`" :rules="req">
                          <NumInput v-model="p.amount"/>
                        </FormItem>
                      </td>
                      <td>
                        <div v-if="p.date > (new Date).serializeLocal()">
                          -
                        </div>
                        <Checkbox v-else v-model="p.is_paid"/>
                      </td>
                      <td>
                        <Button type="error" @click="form.payments.splice(i, 1)">
                          <Icon type="ios-trash" size="small"/>
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
          <br>
          <div style="text-align: left">
            <Button @click="addPayment()">Aggiungi pagamento</Button>
          </div>
          <br>
          <br>
          <hr>
          <br>

          <div style="text-align: right">
            &nbsp;
            <Button @click="submit" type="primary">Salva</Button>
            &nbsp;
            <Button @click="$emit('close')" type="error">Annulla</Button>
          </div>
        <!-- </TabPane> -->
      <!-- </Tabs> -->


    </Form>
  </div>
</template>

<script>
export default {
  props: [
    'edit',
  ],

  store: [
    'company'
  ],

  data() {
    var form = Object.assign({
      date: new Date().serializeLocal(),
      is_a: 'inv',
      type: 'rec',
      items: [],
      payments: [],
      company_id: this.$store.company.id,
      ritenuta: '',
    }, this._.clone(this.edit) || {})

    for (var i in form.items) {
      let it = form.items[i]
      if (!('iva_percent' in it)) this.$set(it, 'iva_percent', 0)
      if (!('scaricabile' in it)) this.$set(it, 'scaricabile', 100)
      if (!('amount' in it)) this.$set(it, 'amount', '')
    }

    if (form.is_a == 'ric') {
      form.type = 'sent'
    }

    return {
      form,
      ledgers: null,
      contacts: null,
      item_descriptions: [],
      next_number: 1,
    }
  },

  computed: {
    is_sent() {
      return this.form.type == 'sent'
    },
    is_inv() {
      return this.form.is_a == 'inv'
    },
    is_ric() {
      return this.form.is_a == 'ric'
    },
    is_nacc() {
      return this.form.is_a == 'nacc'
    },
    is_inv_or_nacc() {
      return this.is_inv || this.is_nacc
    },
    has_iva() {
      return this.$store.company.has_iva
    },
    has_iva_controls() {
      return this.is_inv_or_nacc && this.has_iva
    },
    cassa_e_banca() {
      return (this.ledgers || []).filter(l => {
        return l.code.startsWith('CAS') || l.code.startsWith('B') || l.code == 'CON'
      })
    },
    sum() {
      var sum = -this.form.ritenuta
      this.form.items.forEach(l => sum += (l.amount || 0) * (1 + l.iva_percent/100))
      sum = isNaN(sum) ? 0 : sum
      return Math.round(sum*100)/100
    },
    sum_to_pay() {
      var sum = this.sum
      this.form.payments.forEach(l => sum -= l.amount)
      return Math.round(sum*100)/100
    },
    generates_credit() {
      return ((this.is_inv || this.is_ric) && this.is_sent) || (this.is_nacc && !this.is_sent)
    },
  },

  beforeDestroy() {
    this.$root.$off('contacts', this.refreshContacts)
  },
  mounted() {
    this.$root.$on('contacts', this.refreshContacts)
    this.refreshContacts()
    if (!this.form.id) {
      this.$http.get('invoices/' + this.$store.company.id + '/next-number', {
        params: {is_a: this.form.is_a}
      }).then(res => {
        this.next_number = res.data
        this.form.number = this.next_number
      })
    }
    this.$http.get('ledgers?company_id=' + this.$store.company.id).then(res => {
      this.ledgers = res.data
    })
    this.$http.get('item-descriptions?company_id=' + this.$store.company.id).then(res => {
      this.item_descriptions = res.data
    })
    if (!this.form.items.length) {
      this.addLine()
    }
  },

  methods: {
    updateAmountOfLine (line) {
      this.$set(line, 'amount', (line.total / (100 + 1*line.iva_percent) * 100).toFixed(2))
    },
    refreshContacts() {
      var params = {
        with: this.form.contact_id,
      }
      this.$http.get('contacts?company_id=' + this.$store.company.id, {
        params
      }).then(res => {
        this.contacts = res.data
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return this.$Message.error('Controllare i campi')
        }
        if (!this.sum) {
          return this.$Message.error('Inserire almeno una linea')
        }
        if (!this.form.id && this.is_inv_or_nacc && this.form.type == 'sent' && this.form.number != this.next_number) {
          if (!confirm('Attenzione, il numero del documento è stato modificato, continuare?')) return
        }

        this.loading = true
        this.$http.post('invoices', this.form).then(res => {
          this.$emit('close')
          this.$emit('saved', res.data)
          this.$root.$emit('invoices')
        }).finally(res => {
          this.loading = false
        })
      })
    },
    addLine() {
      console.log(this.form)
      this.form.items.push({
        ledger_id: null,
        amount: '',
        iva_percent: 0,
        scaricabile: 100,
      })
    },
    addPayment() {
      this.form.payments.push({
        ledger_id: null,
        amount: this.sum_to_pay,
        date: new Date().serializeLocal(),
      })
    },

    autoSetIva (line) {
      let led = this.$store.company.cc.find(c => c.ledger.id == line.ledger_id)
      console.log('ledger:', led)
      if (!led) {
        this.$set(line, 'iva_manual', false)
        this.$set(line, 'iva_manual', true)
        this.$set(line, 'iva_percent', 0)
        this.$set(line, 'scaricabile', 0)
      } else {
        this.$set(line, 'iva_manual', true)
        this.$set(line, 'iva_percent', led.imp)
        this.$set(line, 'scaricabile', led.detr)
        this.updateAmountOfLine(line)
      }
    }
  },

  watch: {
    'form.is_a'(val) {
      this.form.type = this.is_inv ? 'rec' : 'sent'
    },
    'form.type'(val) {
      if (this.is_inv && this.form.type == 'sent') {
        this.form.number = this.next_number
      }
    }

  }

}
</script>

<style lang="css">
</style>
